/* eslint-disable no-console */
//const dev: boolean = process.env.NODE_ENV === "development";
const dev = true;
export const DevLog: (...param: any[]) => void = dev ? console.log.bind(null) : () => {};

export const DevWarn: (...param: any[]) => void = dev ? console.warn.bind(null) : () => {};

export const DevError: (...param: any[]) => void = dev ? console.error.bind(null) : () => {};

